import React, { useState, useEffect, useRef } from "react";
import "./sidebar.css";

const CloseFuncCaller = (props, sideNumber) => {
  const callToClose = props.CloseSidebar;

  callToClose(props.sideNum);
};
const OutSideClicked = (sideBarRef, sideNumber) => {
  useEffect(() => {
    function handleClickOutside(event) {
      if (sideBarRef.current && !sideBarRef.current.contains(event.target)) {
        CloseFuncCaller(sideNumber);
      } else {
        return null;
      }
    }
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  });
};
const Sidebar = (props) => {
  const [sideNumber, setsideNumber] = useState(props);
  const sideBarRef = useRef(null);

  // OutSideClicked(sideBarRef, sideNumber);

  // const [bodyClicked, setBodyClicked] = useState(false);
  // useEffect(() => {
  //   document.addEventListener("click", (event) => {
  //     if (sideBarRef.current && !sideBarRef.current.contains(event.target)) {
  //       setBodyClicked(true);
  //       console.log(bodyClicked);
  //     }
  //   });
  //   return () => {
  //     document.removeEventListener("click", null);
  //   };
  // }, []);
  return (
    <React.Fragment>
      <div className="sidebar" ref={sideBarRef}>
        <div className="sidebar-content h-100">
          <div className="sidebar-header">
            <div
              title="close"
              className="closeSidebar"
              onClick={props.CloseSidebar}
            >
              <button type="button" className="close-sidebar-btn">
                <svg
                  focusable="false"
                  viewBox="0 0 28 28"
                  class="closeSide-icon"
                  aria-hidden="true"
                  data-hb-id="pl-icon"
                >
                  <path d="M15.4 14l3.3-3.3c.4-.4.4-1 0-1.4s-1-.4-1.4 0L14 12.6l-3.3-3.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l3.3 3.3-3.3 3.3c-.4.4-.4 1 0 1.4.2.2.4.3.7.3s.5-.1.7-.3l3.3-3.3 3.3 3.3c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4L15.4 14z"></path>
                </svg>
              </button>
            </div>
            <div className="sidebar-header-text">
              <span>Product Details</span>
            </div>
          </div>
          <div className={props.className}>{props.children}</div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default Sidebar;
